export default "__VITE_ASSET__CnHjHzHh__"